<template>
  <!-- 默认进件页面(红色第一套) -->
  <div class="container u-flex-col" ref="container" v-cloak>
    <div class="top" id="target" ref="top">
      <!-- 顶部-->
      <div class="container-top u-flex-col u-row-center">
        <div class="top-content">请完善以下信息，最高可获得20W额度</div>
        <div class="bottom-content u-flex">
          <img src="../assets/images/icon_reg_7_1.png" />
          <span>信息仅用于核验身份，我们将严格保护您的个人信息</span>
        </div>
      </div>

      <div class="register-form">
        <!-- 位置 -->
        <div class="location">
          <div class="location-top u-flex u-row-between">
            居住地区
            <div
              class="lct-city u-flex u-row-center"
              @click="handleClickPosition"
            >
              <span>{{ addressPositionName }}</span>
              <img src="../assets/images/icon_tl7_1.png" />
            </div>
          </div>
          <div class="location-bottom u-flex">
            <img src="../assets/images/icon_reg_7_2.png" />
            <p class="lct-tips">金融机构不支持跨城市贷款，请选择您的常驻城市</p>
          </div>
        </div>

        <div class="line-division"></div>

        <!-- 真实姓名 -->
        <div class="user-info" ref="realName">
          <van-cell-group>
            <van-field
              label="真实姓名"
              v-model.trim="form.realName"
              class="inp-elem"
              placeholder="请输入您的真实姓名(已加密)"
              @blur="handleBlur(0)"
              clearable
              input-align="right"
              :readonly="isReadonly"
            />
          </van-cell-group>
        </div>

        <div class="line-division"></div>

        <!-- 身份证号 -->
        <div class="user-info" ref="idCard">
          <van-cell-group>
            <van-field
              label="身份证号码"
              v-model.trim="form.idCard"
              maxlength="18"
              class="inp-elem"
              placeholder="请输入您的身份证号(已加密)"
              @blur="handleBlur(1)"
              clearable
              input-align="right"
              :readonly="isReadonly"
            />
          </van-cell-group>
        </div>
      </div>

      <div v-if="this.basicInputNum >= 2" class="register-form rfa0">
        <!-- 补充资产信息 -->
        <div class="asset-info u-flex">
          <p class="text_hint_1">填写最后一步，通过率可提升</p>
          <p class="text_hint_2">96%</p>
        </div>

        <div class="line-division"></div>

        <van-collapse v-model="activeNames">
          <!-- 芝麻分 -->
          <van-collapse-item
            ref="credit"
            class="custom-collapse-item"
            title="芝麻分"
            name="1"
            :value="this.assetFromJS.credit"
          >
            <template #icon>
              <img
                class="ld-left-icon"
                src="../assets/images/icon_reg_tl3_4.png"
              />
            </template>
            <template #right-icon>
              <div class="ld-right-div u-flex">
                <img
                  class="ld-right-icon"
                  src="../assets/images/icon_right_gray.png"
                />
              </div>
            </template>
            <div class="tags">
              <van-row gutter="10">
                <van-col
                  class="u-flex u-row-center"
                  v-for="(item, index) in formItemData.credit"
                  :key="index"
                  :class="item.active ? 'active' : 'tags-item'"
                  span="6"
                  @click="handleChooseCreditCredit(index)"
                >
                  <div class="u-flex u-col-center u-row-center">
                    {{ item.dictLabel }}
                  </div>
                </van-col>
              </van-row>
            </div>
          </van-collapse-item>
          <!-- 公积金 -->
          <van-collapse-item
            v-if="this.assetFromJS.credit"
            title="公积金"
            name="2"
            :value="this.assetFromJS.accumulation"
          >
            <template #icon>
              <img class="ld-left-icon" src="../assets/images/icon_reg_5.png" />
            </template>
            <template #right-icon>
              <div class="ld-right-div u-flex">
                <img
                  class="ld-right-icon"
                  src="../assets/images/icon_right_gray.png"
                />
              </div>
            </template>
            <div class="tags">
              <van-row gutter="10">
                <van-col
                  class="u-flex u-row-center"
                  v-for="(item, index) in formItemData.accumulation"
                  :key="index"
                  :class="item.active ? 'active' : 'tags-item'"
                  span="8"
                  @click="handleChooseAccumulation(index)"
                >
                  <div class="u-flex u-col-center u-row-center">
                    {{ item.dictLabel }}
                  </div>
                </van-col>
              </van-row>
            </div>
          </van-collapse-item>
          <!-- 社保 -->
          <van-collapse-item
            v-if="this.assetFromJS.accumulation"
            title="社保"
            name="3"
            :value="this.assetFromJS.social"
          >
            <template #icon>
              <img class="ld-left-icon" src="../assets/images/icon_reg_6.png" />
            </template>
            <template #right-icon>
              <div class="ld-right-div u-flex">
                <img
                  class="ld-right-icon"
                  src="../assets/images/icon_right_gray.png"
                />
              </div>
            </template>
            <div class="tags">
              <van-row gutter="10">
                <van-col
                  class="u-flex u-row-center"
                  v-for="(item, index) in formItemData.social"
                  :key="index"
                  :class="item.active ? 'active' : 'tags-item'"
                  span="8"
                  @click="handleChooseSocial(index)"
                >
                  <div class="u-flex u-col-center u-row-center">
                    {{ item.dictLabel }}
                  </div>
                </van-col>
              </van-row>
            </div>
          </van-collapse-item>
          <!-- 房产 -->
          <van-collapse-item
            v-if="this.assetFromJS.social"
            class="custom-collapse-item"
            title="房产"
            name="4"
            :value="this.assetFromJS.house"
          >
            <template #icon>
              <img class="ld-left-icon" src="../assets/images/icon_reg_7.png" />
            </template>
            <template #right-icon>
              <div class="ld-right-div u-flex">
                <img
                  class="ld-right-icon"
                  src="../assets/images/icon_right_gray.png"
                />
              </div>
            </template>
            <div class="tags">
              <van-row gutter="10">
                <van-col
                  class="u-flex u-row-center"
                  v-for="(item, index) in formItemData.house"
                  :key="index"
                  :class="item.active ? 'active' : 'tags-item'"
                  span="8"
                  @click="handleChooseHouse(index)"
                >
                  <div class="u-flex u-col-center u-row-center">
                    {{ item.dictLabel }}
                  </div>
                </van-col>
              </van-row>
            </div>
          </van-collapse-item>
          <!-- 车产 -->
          <van-collapse-item
            v-if="this.assetFromJS.house"
            title="车产"
            name="5"
            :value="this.assetFromJS.car"
          >
            <template #icon>
              <img class="ld-left-icon" src="../assets/images/icon_reg_8.png" />
            </template>
            <template #right-icon>
              <div class="ld-right-div u-flex">
                <img
                  class="ld-right-icon"
                  src="../assets/images/icon_right_gray.png"
                />
              </div>
            </template>
            <div class="tags">
              <van-row gutter="10">
                <van-col
                  class="u-flex u-row-center"
                  v-for="(item, index) in formItemData.car"
                  :key="index"
                  :class="item.active ? 'active' : 'tags-item'"
                  span="8"
                  @click="handleChooseCar(index)"
                >
                  <div class="u-flex u-col-center u-row-center">
                    {{ item.dictLabel }}
                  </div>
                </van-col>
              </van-row>
            </div>
          </van-collapse-item>
          <!-- 职业 -->
          <van-collapse-item
            v-if="this.assetFromJS.car"
            title="职业"
            name="6"
            :value="this.assetFromJS.profession"
          >
            <template #icon>
              <img class="ld-left-icon" src="../assets/images/icon_reg_9.png" />
            </template>
            <template #right-icon>
              <div class="ld-right-div u-flex">
                <img
                  class="ld-right-icon"
                  src="../assets/images/icon_right_gray.png"
                />
              </div>
            </template>
            <div class="tags">
              <van-row gutter="10">
                <van-col
                  class="u-flex u-row-center"
                  v-for="(item, index) in formItemData.profession"
                  :key="index"
                  :class="item.active ? 'active' : 'tags-item'"
                  span="8"
                  @click="handleChooseProfession(index)"
                >
                  <div class="u-flex u-col-center u-row-center">
                    {{ item.dictLabel }}
                  </div>
                </van-col>
              </van-row>
            </div>
          </van-collapse-item>
        </van-collapse>
      </div>
    </div>

    <!-- 马上申请 -->
    <div class="btn-con">
      <van-button
        class="btn"
        type="default"
        block
        :disabled="this.basicInputNum >= 1 ? false : true"
        @click="handleSubmitTl7"
        :loading="loading"
        loading-type="spinner"
      >
        马上申请
      </van-button>
    </div>

    <!-- 定位城市下拉选 -->
    <van-popup
      v-model="showPickerCity"
      position="bottom"
      safe-area-inset-bottom
      round
    >
      <van-picker
        show-toolbar
        :columns="areaList"
        @change="onCityChange"
        @confirm="onAreaConfirm"
        @cancel="showPickerCity = false"
        value-key="localName"
      >
        <div slot="title" class="picker-title u-text-center">
          <p>请选择定位城市</p>
          <p class="pa">
            准确的贷款申请城市将决定我们是否能为您提供贷款服务，请按您所在地如实填写
          </p>
        </div>
      </van-picker>
    </van-popup>

    <!-- 提交进件信息注册的我已知晓下一步的弹窗 -->
    <Agreement
      @handleGoOn="handleGoOn"
      :incomingShow="incomingShow"
      :sendData="sendData"
      :form="form"
      :applyTime="applyTime"
      :companys="companys"
      :companyAlias="companyAlias"
      :productId="productId"
      :applyId="applyId"
      :source="2"
    />

    <!-- 退出阻断弹窗 -->
    <van-popup
      v-model="returnShow"
      :close-on-click-overlay="false"
      :style="{
        width: '80%',
        height: 'auto',
      }"
      round
    >
      <div class="return-con u-text-center">
        <h3>
          距离<span>{{ this.form.loanAmount }}</span
          >元额度
        </h3>
        <h1>仅剩1步</h1>
        <p class="return-con-tips">确定要离开吗？</p>
        <van-button
          class="return-con-btn"
          block
          color="#1d68ff"
          round
          @click="returnShow = false"
        >
          继续填写
        </van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { applyCommon } from "@/mixins/applyCommonTl1.js";
import { mapPosition } from "@/mixins/mapPosition.js";
import { applyBus } from "@/mixins/applyBusEntry.js";
import { ref } from "vue";
import Agreement from "../components/Agreement";
export default {
  name: "RegisterEntryTl1",
  mixins: [applyCommon, mapPosition, applyBus],
  data() {
    return {
      activeNames: ["1"],
      positionStatus: false, // 定位是否成功，默认false
      positionCityStatus: false, // 百度定位中是否包含城市信息(如果不包含也相当于定位失败)
      provinceArr: undefined, // 百度定位中是否包含城市信息(如果不包含也相当于定位失败)-集合中是对应省的一条数据
      address: {
        // 定位地址
        province: "", // 省
        city: "", // 市
      },
      areaList: [
        // 自定义省数据二级结构
        { values: [] },
        { values: [] },
      ],
      showPickerCity: false, // 省市联动弹窗状态
      assetFromJS: {
        // 资产提交表单
        credit: "", // 芝麻分
        house: "", // 房产
        car: "", // 车产
        accumulation: "", // 公积金
        social: "", // 社保
        insurance: "", // 商业保险
        profession: "", // 职业
        jdIous: "", //京东白条
        antCreditPay: "", //蚂蚁花呗
      },
      form: {
        // 提交表单
        channelNo: this.$route.query.source, // 渠道标识
        loanAmount: 20000, // 借款金额
        loanPeriod: 12, // 借款期限
        loanPurpose: this.$route.query.purpose, // 借款用途
        realName: "", // 姓名
        idCard: "", // 身份证号码
        credit: "", // 芝麻分
        assets: [], // 个人资产
        gpsCityName: "", // 省市展示名称
        cityId: "", // 城市ID
        provinceId: "", // 省ID
        reqId: this.$route.query.reqId, // 流水号
        jdIous: "", //京东白条
        antCreditPay: "", //蚂蚁花呗
      },
      isReadonly: false, //姓名和身份证是否只读
      incomingShow: false, // 提交进件信息弹窗
      returnShow: false, // 退出阻断弹窗状态
      tdArea: "", // 特定机构的地理位置信息
      isSpecificInstitution: false, //是否需要展示特定机构的协议
      companys: "", // 公司名称集合
      companyAlias: "", // 公司别名
      loaclTitle: "", // 局部协议弹窗顶部title,
      brand: this.$route.query.brand, // 设备型号
      downPageUrl: this.$route.query.downPageUrl, // 进件结果下载页地址
      applyId: "", // 进件申请ID
      applyTime: "", // 进件申请时间
      hasPushSuccess: undefined, // 是否推送成功
      env: process.env.NODE_ENV, // 是否是线上环境
      loading: false, //确认额度按钮点击状态
      isRedirectProductsPage: parseInt(
        this.$route.query.isRedirectProductsPage
      ), // 标识是否是贷超流程的字段1是 0否
      isRedirectWorkWeixinPage: parseInt(
        this.$route.query.isRedirectWorkWeixinPage
      ), // 标识如果不是贷超流程需要用此字段进行判断是否跳转引导企业微信页面中，引导用户用企业微信扫码联系客服1是 0否
      workWeixinUrl: this.$route.query.workWeixinUrl, // 跳转微信地址url
      redirectUrl: "", // 重定向链接
      productId: null, // 产品id
      sendData: null,
      isInputName: false, //是否输入姓名
      isInputIdCard: false, //是否输入身份证
    };
  },
  components: {
    Agreement,
  },
  mounted() {
    this.addHistory(); // 添加浏览器浏览记录
    this.checkPosition(); // 获取是否支持定位

    this.$nextTick(() => {
      this.handleLoadFinish(3);
    });
  },
  destroyed() {
    // 页面销毁时必须要移除这个事件，vue 不刷新页面，不移除会重复执行
    window.removeEventListener("popstate", this.openReturnPop, false);
  },
  watch: {
    //弹框监听，当弹框显示的时候，pushState 添加一个历史，供返回键使用
    returnShow(newVal) {
      if (newVal === true) {
        window.history.pushState(null, null, document.URL);
      }
    },
  },
  computed: {
    addressPositionName() {
      // 顶部定位名称
      if (this.positionStatus) {
        return `${this.address.city}`;
      } else {
        if (this.form.gpsCityName) {
          return this.form.gpsCityName;
        } else {
          return "定位失败";
        }
      }
    },
  },
  methods: {
    // 监听表单blur
    handleBlur(index) {
      switch (index) {
        case 0: // 姓名输入框失去光标
          if (this.form.realName === "") {
            this.$toast("请输入正确的姓名");
            this.isInputName = false;
            return;
          }
          this.isInputName = true;
          if (this.isInputIdCard) {
            this.checkApplyBefore();
          }
          break;
        case 1: // 身份证输入框失去光标
          if (this.form.idCard !== "") {
            if (!this.regTest.regIdcard.test(this.form.idCard)) {
              this.$toast("请输入正确的身份证号码");
              this.isInputIdCard = false;
              return;
            }
            this.isInputIdCard = true;
            if (this.isInputName) {
              this.checkApplyBefore();
            }
          }
          break;
      }
    },

    // step1 进件申请之前校验
    async checkApplyBefore() {
      // // 按钮loading
      this.loading = false;
      this.basicInputNum = 2;
      this.isReadonly = true;
    },
  },
  setup() {
    const activeNames = ref(["1"]);
    return { activeNames };
  },
};
</script>

<style lang="scss" scoped src="@/assets/styles/registerEntry_tl1.scss"></style>
